import { createAction } from "redux-actions";
import { FETCH_DEVICE, UPDATE_DEVICE_IP } from "../constants";
import {  getDeviceInfo } from "./../services/devices";
// import { urlDevices } from "./../services/urls";



export const getDeviceData= createAction(FETCH_DEVICE, (user) => getDeviceInfo(user))
export const updateIpDevice= createAction(UPDATE_DEVICE_IP, (ip) => ip)